import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';

export const CONSTANTS_GENERATION__value_range = {
  /*
   * CONTROL NET
   */
  CONTROL_NET_IMAGE_WEIGHT: new DTO__number_range(0, 100),

  CONTROL_NET_STEPS_BEGIN: new DTO__number_range(0, 99),
  CONTROL_NET_STEPS_END: new DTO__number_range(1, 100),

  CONTROL_NET_STEPS_START_DEFAULT: new DTO__number_range(0, 49),
  CONTROL_NET_STEPS_END_DEFAULT: new DTO__number_range(50, 100),

  IMAGE_CANVAS_STRENGTH: new DTO__number_range(0, 100),

  IP_ADAPTER_SCALE_MASTER: new DTO__number_range(0, 100),
  IP_ADAPTER_IMAGE_WEIGHT: new DTO__number_range(0, 100),

  LORA_WEIGHT_MASTER: new DTO__number_range(0, 100),
  // todo: use -100 .. 200
  LORA_WEIGHT: new DTO__number_range(-1, 2),

  INFERENCE_STEPS: new DTO__number_range(1, 100),

  UNET_FREEU_SCALE: new DTO__number_range(-1, 3),
  /*
   * TEXT
   */
  CLIP_SKIP: new DTO__number_range(0, 12),

  GUIDANCE_SCALE: new DTO__number_range(1, 30),

  //todo: convert to 0..100 and normalize on generator
  GUIDANCE_RESCALE: new DTO__number_range(0, 1.0),

  WEIGHT_RANGE: new DTO__number_range(1.0, 1.75),
  WEIGHT_ALLOWED: new DTO__number_range(-1.0, 2.0),

  IMAGE_SIZE_IN: new DTO__number_range(64, 2048),
  IMAGE_SIZE_OUT: new DTO__number_range(64, 16_384),

  ZERO: new DTO__number_range(0, 0),
  ZERO_TO_ONE: new DTO__number_range(0, 1),

  ZERO_TO_FIVE: new DTO__number_range(0, 5),
  ZERO_TO_10: new DTO__number_range(0, 10),
  ZERO_TO_50: new DTO__number_range(0, 50),
  ZERO_TO_1024: new DTO__number_range(0, 1024),

  ONE_TO_TEN: new DTO__number_range(1, 10),
  ONE_TO_50: new DTO__number_range(1, 50),

  COLOR: new DTO__number_range(0, 255),

  IMAGE_SIZE_ASPECT_RATIO: new DTO__number_range(1, 16),
};
